import { t } from '@lingui/macro';
import { NumberRangeFilter } from './NumberRangeFilter';
export const noticePeriodMonthsFilterLabel = () => t({
    message: 'Notice period months',
    comment: 'Insights: Notice period months filter',
});
export function NoticePeriodMonthsFilter() {
    return (<NumberRangeFilter name="metadataDocumentNoticePeriodMonths" label={noticePeriodMonthsFilterLabel()}/>);
}
